
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import 'moment/locale/pt-br';
import Swal from 'sweetalert2';
import SteppedForm from "../components/stepped_form";
import AjaxLoader from '../utilities/ajax-loader';

export default class GenerateSchedules {
	constructor($scope, { onSave }) {
		this.$scope = $scope;
    this.weekDay = -1;
		this.requiredFields = ['start-at', 'end-at', 'schedule-time'];
		this.$generatedSchedules = this.$scope.querySelector('.generated-schedules');
    this._onSave = onSave || (() => {});
		$(this.$scope).on('click', '.generated-schedules span.schedule-to-save > .remove', (ev) => this.removeSchedule(ev));
		this.steppedForm = new SteppedForm(
			this.$scope.querySelector('.stepped-form'),
			{
				onComplete: this.save.bind(this),
				beforeNext: this.beforeNext.bind(this)
			}
		);
	}

	beforeNext(step) {
		if (step.classList.contains('stepped-form-configuration'))
			return this.beforeGenerate();

		this.beforeSaveSchedules();
	}

	save() {
    this._onSave(this.schedules);
    this.reset();
	}

	beforeGenerate() {
		if (!this.validateRequiredFields()) {
			this.warning('Preencha os campos obrigatórios antes de continuar');
			return false;
		}

		return this.generateSchedules();
	}

  beforeSaveSchedules() {}

  reset() {
    this.requiredFields.forEach((id) => {
      this.$scope.querySelector(`input[name="auto[${id}]"]`).value = '';
    });

    this.steppedForm.fromScratch();
  }

	validateRequiredFields() {
		return [...this.requiredFields].reduce((accumulator, id) => {
			let $el = this.$scope.querySelector(`input[name="auto[${id}]"]`),
				$formGroup = $el.closest('.form-group'),
				_isEmpty = isEmpty($el.value);

			$formGroup.classList.toggle('has-error', _isEmpty);
			$formGroup.querySelector('.help-block').innerHTML = _isEmpty ? 'Campo é Obrigatório' : '';

			return accumulator &= !_isEmpty;
		}, true);
	}

	generateSchedules() {
		AjaxLoader.show();

		this.schedules = [];
		let startAtAry = this.$scope.querySelector('input[name="auto[start-at]"]').value.split(':'),
			endAtAry = this.$scope.querySelector('input[name="auto[end-at]"]').value.split(':'),
			interval = +this.$scope.querySelector('input[name="auto[schedule-time]"]').value,
			fullHour = this.$scope.querySelector('input[name="auto[full-hour]"]').checked,
			startAt = moment().hour(+startAtAry[0]).minute(+startAtAry[1]).millisecond(0),
			endAt = moment().hour(+endAtAry[0]).minute(+endAtAry[1]).millisecond(0);

		while(startAt < endAt) {
			this.schedules.push({
				startTime: startAt.format('HH:mm'),
        endTime: startAt.add(interval, 'minutes').format('HH:mm'),
        weekDay: this.weekDay
			});

			if (fullHour && startAt.minute() > 0 && startAt.minute() < 59)
				startAt.add(60 - startAt.minute(), 'minutes')

			if (this.schedules.length > 50)
				break;
		}

		AjaxLoader.hide();
		return this.showGeneratedSchedules(this.schedules);
	}

	showGeneratedSchedules(schedules) {
		let index = 0;
		this.$generatedSchedules.innerHTML = schedules.reduce((html, schedule) => {
			return html + `<span class="schedule-to-save border rounded-full py-1 px-2 m-2 d-flex justify-content-center align-items-center" data-index="${index++}">
				${schedule.startTime} às ${schedule.endTime} <span class="remove"><i class="far fa-times-circle text-xs ml-2 pointer"></i></span>
			</span>`;
		}, '');

		return true;
	}

	removeSchedule(ev) {
		let $span = ev.currentTarget;
		this.schedules.splice($span.closest('.schedule-to-save').dataset.index, 1);
		this.showGeneratedSchedules(this.schedules);
	}

	warning(text) {
		Swal.fire({
			title: 'Atenção!',
			icon: 'warning',
			text: text,
		});
	}
}